const TIME_OFF_I18N_PATH = 'schedule_builder.react_page.time_off';

export const REASONS_I18N_PATH = `${TIME_OFF_I18N_PATH}.reasons`;
export const CATEGORIES_I18N_PATH = `${TIME_OFF_I18N_PATH}.categories`;
export const POPUP_I18N_PATH = `${TIME_OFF_I18N_PATH}.popup`;
export const MODAL_I18N_PATH = `${TIME_OFF_I18N_PATH}.confirm_dialog`;
